<template>
  <b-row>
    <b-col
      v-for="(item, index) in tableData"
      :key="index"
      sm="12"
      md="6"
      lg="4"
      xl="3"
    >
      <b-card
        tag="article"
        no-body
        style="border: 1px solid rgba(0, 0, 0, 0.125)"
      >
        <b-card-img
          :src="
            item.defaultImageUrl
              ? item.defaultImageUrl
              : '/image/static/img/nopic.jpg'
          "
          :alt="item.sampleStyleNo"
          top
          @click="detail(item)"
          style="cursor: pointer"
        ></b-card-img>
        <b-card-body>
          <h6 class="card-title">{{ item.sampleStyleNo }}</h6>
          <b-card-text>
            <div class="text_description">
              <span class="table-text">{{ item.desc }}</span>
            </div>
          </b-card-text>
          <b-card-text>
            <span class="table-text">Sample Cost：</span>
            <span class="table-text"><b>{{ item.costMainType }}</b></span>
            <br />
            <span class="table-text">Cost Price：</span>
            <span class="table-text ml-3"><b>{{ item.costPrice }}</b> {{ item.costCurrency }}</span>
            <br />
            <span class="table-text">{{ item.quotedMethod }}&nbsp;&nbsp;Price：</span>
            <span class="table-text text-danger ml-3"><b>{{ item.quotedPrice }}</b> {{ item.quotedCurrency }}</span>
          </b-card-text>
          <div class="d-flex justify-content-between">
            <div>
              <a class="table-text" @click="addCollect(item)" role="button">
                <i v-if="!item.state" class="fa fa-heart-o"></i>
                <i v-else class="fa fa-heart text-danger"></i
                ><span class="ml-2">Like </span>
              </a>
            </div>
            <div>
              <a
                class="table-text"
                @click="addCart(item.sampleCode)"
                role="button"
                ><i class="el-icon-shopping-cart-2"></i>
                <span class="ml-2">Add to cart</span></a
              >
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col v-if="!isShow" style="text-align: center">
      <b-card class="mt-5">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  computed: {},
  components: {},
  // 数据
  data() {
    return {
      productType: 'S'
    }
  },
  props: {
    tableData: {
      default: () => []
    },
    isShow: {
      default: true
    }
  },
  // 侦听器
  watch: {},
  // 事件处理方法
  methods: {
    // 加入收藏/取消收藏
    addCollect(item) {
      let param = {
        sampleCode: item.sampleCode,
        productType: this.productType
      }
      this.$api
        .saveAndCancelCollectApi(param)
        .then(() => {
          this.$set(item, 'state', !item.state)
          if (item.state) {
            this.$message.success(this.$l('tips_collection_ok') || '收藏成功')
          } else {
            this.$message.success(
              this.$l('tips_collection_cancle') || '取消收藏'
            )
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    addCart(sampleCode) {
      this.$api
        .addCartApi({
          sampleCode,
          productType: this.productType
        })
        .then(() => {
          this.$message.success(
            this.$l('tips_add_cart_ok') || '购物车添加成功！'
          )
        })
    },
    detail(val) {
      // 跳转页面
      this.$router.push({
        name: 'digitalExhibitionHall-sampleInfo-detail',
        params: {
          sampleCode: val.sampleCode
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #6c757d;
  font-size: 14.4px;
}
.text_description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  height: 60px;
  line-height: 20px;
}
.text-danger {
  color: #fa5c7c !important;
}
</style>
